var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-model',{ref:"formModel",attrs:{"title":_vm.title,"width":"700","labelWidth":100}},[_c('Button',{attrs:{"slot":"btn","type":"primary"},on:{"click":_vm.addUpdate},slot:"btn"},[_vm._v("提交表单")])],1),_vm._v(" "),_c('createdFlow',{ref:"createdFlow"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705a1f5d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/yhgl/forms/gaoweizuoye.vue
// module id = null
// module chunks = 